import { useMemo, useState } from "react";
import { useContent } from "../context/SiteContext";
import { Container, PageHero, Empty, Loading } from "../components/site/Common";
import { EventCard } from "../components/site/Cards";

const FILTERS = ["All", "Upcoming", "Completed", "Training", "Camps", "Tournaments"];
const match = (e, f) => {
  if (f === "All") return true;
  if (f === "Upcoming") return e.status !== "Completed";
  if (f === "Completed") return e.status === "Completed";
  if (f === "Training") return /training|coaching programme/i.test(e.type);
  if (f === "Camps") return /camp/i.test(e.type);
  if (f === "Tournaments") return /tournament/i.test(e.type);
  return true;
};

export default function Events() {
  const { items } = useContent("events");
  const [f, setF] = useState("All");
  const list = useMemo(() => (items || []).filter((e) => match(e, f)), [items, f]);
  return (
    <>
      <PageHero eyebrow="Events & training" title="Events, camps & tournaments" text="Coaching programmes, camps, district tournaments and association events — upcoming and completed." />
      <section className="py-16 bg-slate-50 min-h-[50vh]">
        <Container>
          <div className="flex flex-wrap gap-2 mb-10" data-testid="events-filters">
            {FILTERS.map((x) => (
              <button key={x} onClick={() => setF(x)} className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${f === x ? "bg-[#0B1F44] text-white" : "bg-white text-slate-600 ring-1 ring-slate-200 hover:bg-slate-100"}`} data-testid={`events-filter-${x.toLowerCase()}`}>{x}</button>
            ))}
          </div>
          {!items ? <Loading /> : list.length === 0 ? <Empty testid="events-empty">No events in this category yet.</Empty> : (
            <div className="grid gap-6 md:gap-8 md:grid-cols-2 lg:grid-cols-3" data-testid="events-grid">{list.map((e) => <EventCard key={e.id} item={e} />)}</div>
          )}
        </Container>
      </section>
    </>
  );
}
